import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChevronDown(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.333 6 9.414 9.92a2 2 0 0 1-2.828 0L2.666 6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
